import { render, staticRenderFns } from "./AddShippingOrderDialog.vue?vue&type=template&id=3cfca24e&scoped=true"
import script from "./AddShippingOrderDialog.vue?vue&type=script&lang=ts"
export * from "./AddShippingOrderDialog.vue?vue&type=script&lang=ts"
import style0 from "./AddShippingOrderDialog.vue?vue&type=style&index=0&id=3cfca24e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cfca24e",
  null
  
)

export default component.exports